import { createContext, useContext, useEffect, useRef, useState } from "react";

import PropTypes from "prop-types";
import classnames from "classnames";

const DropdownContext = createContext(() => {});

export const Dropdown = ({ trigger, children, className = "", menuClassName = "", ...rest }) => {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        if (!open) return;

        const handleOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        const handleKey = (event) => {
            if (event.key === "Escape") setOpen(false);
        };

        document.addEventListener("mousedown", handleOutside);
        document.addEventListener("keydown", handleKey);
        return () => {
            document.removeEventListener("mousedown", handleOutside);
            document.removeEventListener("keydown", handleKey);
        };
    }, [open]);

    const close = () => setOpen(false);

    return (
        <div ref={wrapperRef} className={classnames("relative inline-block", className)} {...rest}>
            <div onClick={() => setOpen((prev) => !prev)}>{trigger}</div>
            {open && (
                <DropdownContext.Provider value={close}>
                    <div
                        className={classnames(
                            "absolute right-0 top-full z-20 mt-1 min-w-[10rem] rounded-md border border-gray-200 bg-white py-1 shadow-lg",
                            menuClassName
                        )}>
                        {children}
                    </div>
                </DropdownContext.Provider>
            )}
        </div>
    );
};

Dropdown.propTypes = {
    trigger      : PropTypes.node.isRequired,
    className    : PropTypes.string,
    menuClassName: PropTypes.string
};

export const DropdownItem = ({ children, onClick, className = "", ...rest }) => {
    const close = useContext(DropdownContext);

    return (
        <div
            className={classnames(
                "flex cursor-pointer items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
                className
            )}
            onClick={() => {
                onClick?.();
                close();
            }}
            {...rest}>
            {children}
        </div>
    );
};

DropdownItem.propTypes = {
    children : PropTypes.node,
    onClick  : PropTypes.func,
    className: PropTypes.string
};
